module.exports = __webpack_public_path__ + "img/9.77c20bc4.png";